import { Box } from "@mui/material";
import styled from "styled-components";

export const BoxStyles = styled(Box)<{
  justifyContent?: string;
  minHeight?: string;
}>`
  && {
    width: 100%;
    min-height: ${(props) => props.minHeight || "fit-content"};
    display: flex;
    justify-content: ${(props) =>
      props.justifyContent ? props.justifyContent : "space-between"};
    align-items: center;
    flex: 1;
    margin-bottom: 16px;
    box-sizing: border-box;
  }
`;
